<template>
  <b-row>
    <b-col md="12">
      <b-card>
        <div class="list-view-drawer__section-title">
          <AppIcon name="location_on" /> Zona
        </div>

        <template v-if="crud.form.id">
          <div class="app-modal-detail-list">
            <div class="app-modal-detail-list__row">
              <span class="app-modal-detail-list__label">Zona</span>
              <span class="app-modal-detail-list__value"><b>{{crud.form.zone.name}}</b></span>
            </div>
            <div class="app-modal-detail-list__row" v-if="crud.form.zone.seller">
              <span class="app-modal-detail-list__label">Vendedor</span>
              <span class="app-modal-detail-list__value">{{crud.form.zone.seller.name}}</span>
            </div>
          </div>

          <div class="text-right mt-2" v-if="!isSeller">
            <b-button variant="outline-danger" size="sm" @click="remove()">
              <AppIcon name="delete" class="mr-1" />Quitar Zona
            </b-button>
          </div>
        </template>

        <template v-else>
          <FindObject type="sellersZone"
                      @select-object="loadZone($event)"
                      :valueID="crud.form.zone_id"/>

          <div class="text-right mt-2" v-if="crud.form.zone_id && !isSeller">
            <b-button variant="dark" size="sm" @click="save()">
              <AppIcon name="save" class="mr-1" />Guardar
            </b-button>
          </div>

          <div class="mt-2" v-if="!crud.form.zone_id && loaded">
            <EmptyState icon="location_on" title="Sin zona asignada" description="Buscá una zona arriba para asignarla a este cliente." />
          </div>
        </template>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './../services'
  import Error from '@/handler/error'
  import Helper from '@/handler/helper'
  import FindObject from '@/components/inc/find/findObject'

  export default {
    components: {
      FindObject,
    },
    props: [
      'customers',
      'customersID',
    ],
    data() {
      return {
        loaded: false,
        crud: {
          form: {
            id: 0,
            zone_id: 0,
            zone: null,
          },
        },
      }
    },
    computed: {
      isSeller() {
        return !!Helper.getSeller()
      },
    },
    watch: {
      customersID: function () {
        this.load()
      }
    },
    mounted() {
      this.load()
    },
    methods: {
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },
      load() {
        let loader = this.$loading.show();
        var result = serviceAPI.obtenerZonaCliente(this.customersID)

        result.then((response) => {
          var data = response.data
          if(data) {
            this.crud.form.id = data.id
            this.crud.form.zone_id = data.zone_id
            this.crud.form.zone = data.zone
          } else {
            this.crud.form.id = 0
            this.crud.form.zone_id = 0
            this.crud.form.zone = null
          }
          this.loaded = true
          loader.hide()
        })
        .catch(error => {
          this.loaded = true
          loader.hide()
          this.$awn.alert(Error.showError(error))
        });
      },
      loadZone(object) {
        if(object){
          this.crud.form.zone = object
          this.crud.form.zone_id = object.id
        } else {
          this.crud.form.zone = null
          this.crud.form.zone_id = 0
        }
      },
      save() {
        if(!this.crud.form.zone_id) {
          this.$awn.alert("Debe seleccionar una zona")
          return
        }

        let loader = this.$loading.show();
        var result = serviceAPI.agregarZonaCliente({
          zone_id: this.crud.form.zone_id,
          customers_id: this.customersID,
        })

        result.then(() => {
          loader.hide()
          this.$awn.success("Datos guardados con éxito");
          this.load()
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
      remove() {
        this.confirmDialog('¿Desea quitar la zona "' + this.crud.form.zone.name + '" de este cliente?', {
          title: 'Quitar Zona',
          icon: 'delete',
          danger: true,
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if(value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarZonaCliente(this.crud.form.id)

            result.then(() => {
              loader.hide()
              this.$awn.success("Registro eliminado");
              this.load()
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
    }
  }
</script>
